module.exports = __webpack_public_path__ + "img/IMG_2041.282a9251.jpg";